<template>
  <div>
    <div class="text-center" v-if="showEarlyText">
      <span class="pretext"> {{this.pretext}}</span>
    </div>
    <div
      :class="secondUI ? 'timer1' : (mobileUI ? (isMobilePdp ? 'mobile-ui-pdp' : 'mobile-ui') : 'timer')"
      class="text-center"
      :style="`color: ${color ? color : '#333'}`"
      v-if="this.now < this.disappear"
    >
      <span class="pretext" v-if="(this.now >= this.start && this.now < this.end && this.pretext && !showEarlyText && !secondUI && !mobileUI)"> {{this.pretext}} </span>
      <span class="pretext1" v-if="(this.now >= this.start && this.now < this.end && this.pretext && !showEarlyText && !isMobilePdp && (secondUI || mobileUI))"> {{this.pretext}} </span>
      <span style="font-size: 0.63em" v-else-if="this.now > this.end">
        {{this.successtext}}
      </span>
      <div class="countdown" v-if="this.now >= this.start && this.now < this.end && showTimer && !secondUI && !mobileUI">
        <div class="time">
          <div class="unit text-uppercase">days</div>
          <span class="number">{{ days | twoDigits }}</span>
        </div>
        <div class="time">
          <div class="unit text-uppercase">hours</div>
          <span class="number">{{ hours | twoDigits }}</span>
        </div>
        <div class="time">
          <div class="unit text-uppercase">minutes</div>
          <span class="number">{{ minutes | twoDigits }}</span>
        </div>
        <div class="time" ref="seconds">
          <div class="unit text-uppercase">seconds</div>
          <span class="number">{{ seconds | twoDigits }}</span>
        </div>
      </div>
      <div class="countdown" style="padding-top: 0px" v-if="this.now >= this.start && this.now < this.end && showTimer && secondUI">
        <div class="time1">
          <span class="number1">{{ days | twoDigits }}</span>
          <div class="unit1 text-uppercase">day</div>
        </div>
        <span class="two-dot">:</span>
        <div class="time1">
          <span class="number1">{{ hours | twoDigits }}</span>
          <div class="unit1 text-uppercase">hrs</div>
        </div>
        <span class="two-dot">:</span>
        <div class="time1">
          <span class="number1">{{ minutes | twoDigits }}</span>
          <div class="unit1 text-uppercase">min</div>
        </div>
        <span class="two-dot">:</span>
        <div class="time1" ref="seconds">
          <span class="number1">{{ seconds | twoDigits }}</span>
          <div class="unit1 text-uppercase">sec</div>
        </div>
      </div>
      <div class="mobileUI countdown pt-0 pb-2" v-if="this.now >= this.start && this.now < this.end && showTimer && mobileUI && !isMobilePdp">
          <span class="number1">{{ days | twoDigits }} {{(days) > 1 ? 'days' : 'day' }} : {{ hours | twoDigits }} hrs : {{ minutes | twoDigits }} min : {{ seconds | twoDigits }} sec</span>
      </div>
      <div class="mobilePDP countdown pt-0" v-if="this.now >= this.start && this.now < this.end && showTimer && mobileUI && isMobilePdp">
          <span class="pretext1" v-if="(this.now >= this.start && this.now < this.end && this.pretext && !showEarlyText && (secondUI || mobileUI))"> {{this.pretext}} </span>
          <span class="number1">{{ days | twoDigits }} {{(days) > 1 ? 'days' : 'day' }} : {{ hours | twoDigits }} hrs : {{ minutes | twoDigits }} min : {{ seconds | twoDigits }} sec</span>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  props: ['starttime', 'endtime', 'color', 'successtext', 'pretext', 'disappeartime', 'showEarlyText', 'showTimer', 'secondUI', 'mobileUI', 'isMobilePdp'],
  data: function () {
    return {
      start: '',
      end: '',
      disappear: '',
      timerInterval: '',
      days: '',
      minutes: '',
      hours: '',
      seconds: '',
      now: ''
    }
  },
  filters: {
    twoDigits (value) {
      return value.toString().padStart(2, '0')
    }
  },
  mounted () {
    this.start = new Date(this.starttime)
    this.end = new Date(this.endtime)
    if (this.disappeartime) {
      this.disappear = new Date(this.disappeartime)
    } else {
      this.disappear = this.end
    }
    this.timerCount()
    this.timerInterval = setInterval(() => {
      this.timerCount()
      this.$emit('getLiveSaleText')
    }, 1000)
  },
  beforeDestroy () {
    clearInterval(this.timerInterval)
  },
  methods: {
    timerCount: function () {
      this.now = new Date()
      let timeLapsed = this.start - this.now
      let timeRemaining = this.end - this.now
      if (timeRemaining < 0) {
        clearInterval(this.timerInterval)
        return
      } else if (timeLapsed < 0 && timeRemaining > 0) {
        this.computeTime(timeRemaining)
      }
    },
    computeTime: function (time) {
      this.days = Math.floor(time / (1000 * 60 * 60 * 24))
      this.hours = Math.floor((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60))
      this.minutes = Math.floor((time % (1000 * 60 * 60)) / (1000 * 60))
      this.seconds = Math.floor((time % (1000 * 60)) / 1000)
    }
  }
}
</script>
<style scoped>
  .countdown {
    display: flex;
    justify-content: center;
    padding-top: 10px;
  }
  .pretext {
    color: #ed2d2f;
    font-size: 24px;
    display: inline-block;
    margin: 10px 0;
    width: 100%;
  }
  .timer {
    font-size: 60px;
    color: #333;
    margin: 15px auto 0;
    margin: 0 auto 30px;
    display: flex;
    flex-direction: column;
  }
  .timer1 {
    font-size: 60px;
    color: #333;
    margin: 15px auto 0;
    display: flex;
    flex-direction: column;
  }
  .time {
    display: inline-block;
    margin: 0 20px;
  }
  .unit {
    font-weight: 300;
    font-size: 25px;
    color: #7B7B72;
    margin-bottom: 20px;
  }
  .number {
    box-shadow: 0 4px 10px rgba(0,0,0,0.2);
    background: #DEDEDE;
    color: #ed2d2f;
    font-weight: bold;
    display: inline-block;
    padding:  0px 40px;
    position: relative;
  }
  .time1 {
    display: inline-block;
    margin: 0 15px;
    text-align: center;
    font-size: 44px;
  }
  .number1 {
    color: #ed2d2f;
    font-weight: bold;
    display: inline-block;
    padding:  0px 10px;
    position: relative;
  }
  .two-dot {
    color: #ed2d2f;
    font-size: 44px;
    font-weight: 600;
  }
  .unit1 {
    font-size: 20px;
    color: #282d3f;
    margin-bottom: 20px;
    font-weight: 600;
  }
  .pretext1 {
    display: inline-block;
    margin: 10px 0;
    width: 100%;
    font-size: 20px;
    color: #282d3f;
    font-weight: 600;
  }
  @media screen and (max-width: 768px) {
    .pretext, .pretext1 {
      font-size: 18px;
    }
   .number {
    padding:  0px 10px;
   }
   .time {
      margin: 0 10px;
    }
    .unit {
      font-size: 20px;
    }
    .mobileUI .number1 {
      font-size: 18px !important;
    }
    .mobile-ui {
      background: #fff;
      margin-top: 0.75rem;
    }
    .mobile-ui .pretext1 {
      margin: 10px 0 0 0;
    }
    .mobilePDP .pretext1 {
      width: fit-content;
      font-size: 15px;
    }
    .mobilePDP .number1 {
      margin: 10px 0;
      font-size: 15px;
      padding: 0 0 0 10px !important;
    }
    .mobile-ui-pdp {
      background-color: rgba(242, 242, 242, 0.8);
      position: absolute;
      bottom: 72px;
      width: 100vw;
      z-index:99;
    }
  }

  @media screen and (max-width: 480px) {
    .mobileUI .number1 {
      font-size: 16px !important;
    }
    .pretext1 {
      font-size: 16px;
    }
    .time {
      margin: 0 10px;
    }
    .time1 {
      font-size: 35px;
      margin: 0 10px;
    }
    .timer {
      font-size: 45px;
      margin: 0 0 25px;
      line-height: 1;
    }
    .timer1 {
      font-size: 45px;
      line-height: 1;
    }
    .unit, .unit1 {
      font-size: 16px;
    }
    .two-dot {
      font-size: 35px;
    }
  }
</style>



// WEBPACK FOOTER //
// Countdown.vue?780658e2